<template>
  <a
      :id="show === true ? 'show-sidebar' : 'close-sidebar'"
      class="btn btn-sm"
      @Click="changeState"
    >
    <div class="toggle-sidebar mob">
          <div class="status_toggle sidebar-toggle d-flex" id="close-sidebar">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <g>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.0003 6.6738C21.0003 8.7024 19.3551 10.3476 17.3265 10.3476C15.2979 10.3476 13.6536 8.7024 13.6536 6.6738C13.6536 4.6452 15.2979 3 17.3265 3C19.3551 3 21.0003 4.6452 21.0003 6.6738Z"
                    stroke="#130F26"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.3467 6.6738C10.3467 8.7024 8.7024 10.3476 6.6729 10.3476C4.6452 10.3476 3 8.7024 3 6.6738C3 4.6452 4.6452 3 6.6729 3C8.7024 3 10.3467 4.6452 10.3467 6.6738Z"
                    stroke="#130F26"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.0003 17.2619C21.0003 19.2905 19.3551 20.9348 17.3265 20.9348C15.2979 20.9348 13.6536 19.2905 13.6536 17.2619C13.6536 15.2333 15.2979 13.5881 17.3265 13.5881C19.3551 13.5881 21.0003 15.2333 21.0003 17.2619Z"
                    stroke="#130F26"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.3467 17.2619C10.3467 19.2905 8.7024 20.9348 6.6729 20.9348C4.6452 20.9348 3 19.2905 3 17.2619C3 15.2333 4.6452 13.5881 6.6729 13.5881C8.7024 13.5881 10.3467 15.2333 10.3467 17.2619Z"
                    stroke="#130F26"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
        </div>
    </a>
  <div class="page-wrapper chiller-theme" :class="show === true ? 'toggled' : ''">
    
    <nav id="sidebar" class="sidebar-wrapper">
      <div class="sidebar-content">
        <div class="sidebar-brand">
          <a href="#">ISP</a>
          <div id="close-sidebar">
            <button @click="changeState">
            <i class="fas fa-times"></i>
          </button>
          </div>
        </div>
        <!-- <div class="sidebar-header">
          <div class="user-pic">
            <img
              class="img-responsive img-rounded"
              src="https://raw.githubusercontent.com/azouaoui-med/pro-sidebar-template/gh-pages/src/img/user.jpg"
              alt="User picture"
            />
          </div>
          <div class="user-info">
            <span class="user-name"
              >Jhon
              <strong>Smith</strong>
            </span>
            <span class="user-role">Administrator</span>
            <span class="user-status">
              <i class="fa fa-circle"></i>
              <span>Online</span>
            </span>
          </div>
        </div> -->
        <!-- sidebar-header  -->
        <!-- <div class="sidebar-search">
          <div>
            <div class="input-group">
              <input
                type="text"
                class="form-control search-menu"
                placeholder="Search..."
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </div> -->
        <!-- sidebar-search  -->
        <div class="sidebar-menu">
          <ul>
            <!-- <li class="header-menu">
              <span>General</span>
            </li> -->
            <!-- <li class="sidebar-dropdown">
              <a href="#">
                <i class="fa fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </a>
              <div class="sidebar-submenu">
                <ul>
                  <li>
                    <a href="#"
                      >Dashboard 1
                      <span class="badge badge-pill badge-success">Pro</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">Dashboard 2</a>
                  </li>
                  <li>
                    <a href="#">Dashboard 3</a>
                  </li>
                </ul>
              </div> 
            </li> -->
            <li class="sidebar-dropdown" v-show="this.userData?.role?.role_id === 1">
              <a href="#">
                <!-- <i class="fa fa-shopping-cart"></i> -->
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.75024 12C2.75024 5.063 5.06324 2.75 12.0002 2.75C18.9372 2.75 21.2502 5.063 21.2502 12C21.2502 18.937 18.9372 21.25 12.0002 21.25C5.06324 21.25 2.75024 18.937 2.75024 12Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M15.2045 13.8999H15.2135"
                        stroke="#130F26"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M12.2045 9.8999H12.2135"
                        stroke="#130F26"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M9.19557 13.8999H9.20457"
                        stroke="#130F26"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Setup</span>
                <!-- <span class="badge badge-pill badge-danger">3</span> -->
              </a>
              <div class="sidebar-submenu">
                <ul>
                  <li>
                    <router-link to="/connection/types" href="/connection/types"
                      >Connection Type
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/pop/types" href="/pop/types">POP Type </router-link>
                  </li>
                  <li>
                    <router-link to="/area/list" href="/area/list"
                      >Area Setup
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/service_type/list" href="/service_type/list"
                      >Service Type Setup
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/customer/create" href="/customer/create"
                      >Customer Create
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/customer/service/list" href="/customer/service/list"
                      >Customer Wise Service
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/employee/list" href="/employee/list"
                      >Employees
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidebar-dropdown" v-show="this.userData?.role?.role_id === 1">
              <router-link to="#">
                <!-- <i class="far fa-gem"></i> -->
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        d="M11.1437 17.8829H4.67114"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.205 17.8839C15.205 19.9257 15.8859 20.6057 17.9267 20.6057C19.9676 20.6057 20.6485 19.9257 20.6485 17.8839C20.6485 15.8421 19.9676 15.1621 17.9267 15.1621C15.8859 15.1621 15.205 15.8421 15.205 17.8839Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14.1765 7.39439H20.6481"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.1153 7.39293C10.1153 5.35204 9.43436 4.67114 7.39346 4.67114C5.35167 4.67114 4.67078 5.35204 4.67078 7.39293C4.67078 9.43472 5.35167 10.1147 7.39346 10.1147C9.43436 10.1147 10.1153 9.43472 10.1153 7.39293Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Operations</span>
              </router-link>
              <div class="sidebar-submenu">
                <ul>
                  <li>
                    <router-link to="/invoice-list" href="/invoice-list"
                      >Invoice List</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/invoice-list-district" href="/invoice-list-district"
                      >Invoice List By District</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/create/manual-invoice" href="/create/manual-invoice"
                      >Manual Billing</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/operation/payment-recieve"
                      href="/operation/payment-recieve"
                      >Payment Recieve</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidebar-dropdown" v-show="this.userData?.role?.role_id === 1">
              <router-link to="#">
                <!-- <i class="far fa-gem"></i> -->
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.1601 8.3L14.4901 2.9C13.7601 2.8 12.9401 2.75 12.0401 2.75C5.75015 2.75 3.65015 5.07 3.65015 12C3.65015 18.94 5.75015 21.25 12.0401 21.25C18.3401 21.25 20.4401 18.94 20.4401 12C20.4401 10.58 20.3501 9.35 20.1601 8.3Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M13.9341 2.83276V5.49376C13.9341 7.35176 15.4401 8.85676 17.2981 8.85676H20.2491"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14.3125 12.9807H9.41248"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M11.8633 15.4308V10.5308"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Other</span>
              </router-link>
              <div class="sidebar-submenu">
                <ul>
                  <li>
                    <router-link to="/customer/list" href="/customer/list"
                      >Customer List
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>

            <li class="sidebar-dropdown" v-show="this.userData?.role?.role_id === 1">
              <router-link to="#">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.1601 8.3L14.4901 2.9C13.7601 2.8 12.9401 2.75 12.0401 2.75C5.75015 2.75 3.65015 5.07 3.65015 12C3.65015 18.94 5.75015 21.25 12.0401 21.25C18.3401 21.25 20.4401 18.94 20.4401 12C20.4401 10.58 20.3501 9.35 20.1601 8.3Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M13.9341 2.83276V5.49376C13.9341 7.35176 15.4401 8.85676 17.2981 8.85676H20.2491"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14.3125 12.9807H9.41248"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M11.8633 15.4308V10.5308"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Report</span>
              </router-link>
              <div class="sidebar-submenu">
                <ul>
                  <li>
                    <router-link to="/report/collection" href="/report/collection"
                      >Collection Report</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/report/due" href="/report/due"
                      >Due Report</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/report/age" href="/report/age"
                      >Ageing Report</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/report/account-statement"
                      href="/report/account-statement"
                      >Account Statement Report</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <!-- Customer Route -->
            <li v-show="this.userData?.role?.role_id === 3">
              <router-link to="/invoice-records">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.1601 8.3L14.4901 2.9C13.7601 2.8 12.9401 2.75 12.0401 2.75C5.75015 2.75 3.65015 5.07 3.65015 12C3.65015 18.94 5.75015 21.25 12.0401 21.25C18.3401 21.25 20.4401 18.94 20.4401 12C20.4401 10.58 20.3501 9.35 20.1601 8.3Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M13.9341 2.83276V5.49376C13.9341 7.35176 15.4401 8.85676 17.2981 8.85676H20.2491"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14.3125 12.9807H9.41248"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M11.8633 15.4308V10.5308"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Own Invoice Records</span>
              </router-link>
            </li>
            <li v-show="this.userData?.role?.role_id === 3">
              <router-link to="/account-records">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.1601 8.3L14.4901 2.9C13.7601 2.8 12.9401 2.75 12.0401 2.75C5.75015 2.75 3.65015 5.07 3.65015 12C3.65015 18.94 5.75015 21.25 12.0401 21.25C18.3401 21.25 20.4401 18.94 20.4401 12C20.4401 10.58 20.3501 9.35 20.1601 8.3Z"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M13.9341 2.83276V5.49376C13.9341 7.35176 15.4401 8.85676 17.2981 8.85676H20.2491"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14.3125 12.9807H9.41248"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M11.8633 15.4308V10.5308"
                        stroke="#130F26"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Own Account Records</span>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- sidebar-menu  -->
      </div>
    </nav>
  </div>
  <!-- page-wrapper -->
</template>

<script>
import $ from "jquery";
import userAPI from "../../services/user.API";
export default {
  name: "SideBar2",
  data() {
    return {
      show: true,
      userData: {},
    };
  },
  mounted() {
    userAPI.getUserProfile().then((res) => {
      console.log("success");
      this.userData = res?.data?.data;
    });

    $(".sidebar-dropdown > a").click(function () {
      $(".sidebar-submenu").slideUp(200);
      if ($(this).parent().hasClass("active")) {
        $(".sidebar-dropdown").removeClass("active");
        $(this).parent().removeClass("active");
      } else {
        $(".sidebar-dropdown").removeClass("active");
        $(this).next(".sidebar-submenu").slideDown(200);
        $(this).parent().addClass("active");
      }
    });

    $("#close-sidebar").click(function () {
      $(".page-wrapper").removeClass("toggled");
    });
    $("#show-sidebar").click(function () {
      $(".page-wrapper").addClass("toggled");
    });

    // if (!this.getUserProfileRole) {
    //   // console.log("logged out");
    //   this.$router.push("/login");
    //   this.$store.dispatch("auth/logout");
    //   this.$store.dispatch("profile/logout");
    // }
  },
  methods: {
    changeState() {
      this.show  ? (this.show = !this.show) : (this.show = true);
      console.log(this.show);
    },
  },
  computed: {
    getUserProfileRole() {
      // console.log(this.$store.state.profile);
      return this.$store.state.profile?.role_id;
    },
  },
};
</script>

<style scoped>
@import url("./sidebar.css");
@import url("https://use.fontawesome.com/releases/v5.0.13/css/all.css");
nav#sidebar {
  position: fixed;
  top: 0;
  z-index: 9;
  height: auto;
  line-height: inherit;
  background: #fff;
  width: 280px;
  text-align: left;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 0 0 21px 0 rgb(89 102 122 / 10%);
  box-shadow: 0 0 21px 0 rgb(89 102 122 / 10%);
  height: 100vh;
}
span {
  letter-spacing: 1px;
  font-family: Roboto;
  text-transform: capitalize;
  color: #2c323f;
  font-weight: 600;
  font-size: 14px;
}
li.sidebar-dropdown {
  display: block;
  width: 100%;
  padding: 5px 20px;
  position: relative;
}
.sidebar-dropdown svg {
  margin-right: 10px;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul {
  width: 100%;
  padding: 0;
  position: relative !important;
}
.sidebar-submenu {
  background: transparent !important;
}
.chiller-theme .sidebar-wrapper .sidebar-header .user-info .user-role,
.chiller-theme .sidebar-wrapper .sidebar-header .user-info .user-status,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu,
.chiller-theme .sidebar-wrapper .sidebar-search .input-group-text,
.chiller-theme .sidebar-wrapper .sidebar-brand > a,
.chiller-theme .sidebar-wrapper .sidebar-menu ul li a,
.chiller-theme .sidebar-footer > a {
  color: #6c757d;
  font-weight: 600;
}
.sidebar-menu {
  border-top: none !important;
  padding-top: 20px;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li {
  padding-left: 10px;
  font-size: 12px;
}
@media only screen and (max-width: 900px) {
  a#close-sidebar {
    position: absolute;
    top: 0;
    height: 40px;
    margin-top: -62px;
    z-index: 10;
    background: transparent;
    transition: none;
  }
  .page-wrapper.chiller-theme {
    display: none;
  }
  .page-wrapper.chiller-theme.toggled {
    display: block;
  }
  div#close-sidebar {
    display: block!important;
  }
}

div#close-sidebar {
  display: none;
}
</style>
